import React from "react";
import { Link } from "react-router-dom";

const AIXrayAnalysisCTA = () => {
  return (
    <section className="bg-gradient-to-r from-orange-500 to-orange-600 py-10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 mb-6 md:mb-0">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              Revolutionary AI X-ray Analysis
            </h2>
            <p className="text-white text-base mb-4">
              Our platform features advanced AI technology that analyzes dental X-rays to detect cavities and anatomical anomalies with 95% accuracy - helping you provide better care while saving time.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/solutions/clinical-tools" className="bg-white text-orange-600 hover:bg-gray-100 font-bold py-2 px-5 rounded-lg transition duration-300 text-center">
                Learn More
              </Link>
              <Link to="#schedule-demo" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-orange-600 font-bold py-2 px-5 rounded-lg transition duration-300 text-center">
                Request Demo
              </Link>
            </div>
          </div>
          <div className="md:w-2/5">
            <div className="bg-white p-3 rounded-lg shadow-lg">
              <img 
                src="/assets/ai-xray-analysis.svg" 
                alt="AI X-ray Analysis" 
                className="rounded w-full h-auto"
                style={{ maxHeight: "220px" }}
              />
              <div className="bg-gray-50 p-3 mt-2 rounded">
                <div className="flex items-center mb-1">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  <p className="text-gray-700 text-sm font-medium">95% Detection Accuracy</p>
                </div>
                <div className="flex items-center mb-1">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  <p className="text-gray-700 text-sm font-medium">Instant Analysis</p>
                </div>
                <div className="flex items-center">
                  <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  <p className="text-gray-700 text-sm font-medium">Enhanced Patient Education</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIXrayAnalysisCTA; 